import './style.scss';

import Swiper from 'swiper/bundle';

import 'swiper/css/bundle';

let swiper = undefined;
const swiperElement = document.getElementsByClassName('blog-slider');
const swiperWrapper = document.getElementsByClassName("swiper-wrapper");
const swiperSlide = document.getElementsByClassName("swiper-slide");

function initSwiper() {
  if (swiperElement) {
    const screenWidth = window.innerWidth;

    if (screenWidth < 992 && swiper == undefined) {
      swiper = new Swiper('.blog-slider', {
        slidesPerView: 1.2,
        spaceBetween: 32,
        centeredSlides: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          767: {
            slidesPerView: 1.8,
          }
        }
      });
    } else {
      if (screenWidth >= 992 && swiper !== undefined) {
        swiper.destroy();
        swiper = undefined;
        [...swiperWrapper].forEach(elem => {
          elem.removeAttribute('style');
        });
        [...swiperSlide].forEach(elem => {
          elem.removeAttribute('style');
        });
      }
    }
  } else {
    return;
  }
}

initSwiper();

window.addEventListener('resize', initSwiper);
